import type {
  UserMergeAccountPurposeApiData,
  UserMergeAccountPurposeApiResponses,
  UserMergeApiData,
  UserMergeApiResponses,
  UserMergeCandidateDismissalApiData,
  UserMergeCandidateDismissalApiResponses,
  UserMergeCandidatesApiData,
  UserMergeCandidatesApiResponses,
  UserMergePreviewApiData,
  UserMergePreviewApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getUserMergeUrls = {
  getUserMergeCandidates: dataEndpoint<UserMergeCandidatesApiData, UserMergeCandidatesApiResponses>({
    getUrl: (queryParams) => apiUrl('users/duplicates/', queryParams)
  }),
  postUserMergePreview: responseEndpoint<UserMergePreviewApiData, UserMergePreviewApiResponses>({
    getUrl: () => apiUrl('users/duplicates/preview/'),
    getBody: (data) => data
  }),
  postUserMerge: responseEndpoint<UserMergeApiData, UserMergeApiResponses>({
    getUrl: () => apiUrl('users/duplicates/merge/'),
    getBody: (data) => data
  }),
  postUserMergeCandidateDismissal: responseEndpoint<
    UserMergeCandidateDismissalApiData,
    UserMergeCandidateDismissalApiResponses
  >({
    getUrl: () => apiUrl('users/duplicates/dismiss/'),
    getBody: (data) => data
  }),
  postUserMergeAccountPurpose: responseEndpoint<UserMergeAccountPurposeApiData, UserMergeAccountPurposeApiResponses>({
    getUrl: () => apiUrl('users/duplicates/account-purpose/'),
    getBody: (data) => data
  })
};
